//Website UI Components 
import NavMenu from '../section/LoggedInNav.js';

import LoginSteps from '../components/LoginSteps.js';
import AWSLoginSection from '../components/aws_login_component.js';
import SITELINKS from '../section/Footer.js';
import Banner from '../section/Title.js';


//boostrap resources 
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';

import { useAuthenticator } from '@aws-amplify/ui-react';


/*Pending Things to Add

Instructions Component 
News Announcements Component
Previous Announcements Component 
Extra Information Component (how to use the site) 


AWS LOGIN SECTION IN RIGHT CONTENT DIV WILL BE MOVED TO ITS OWN FILE CALLED AWS_Login_Component

*/


export const PublicPage = () => {
  const { isPending } = useAuthenticator((context) => [ context.isPending ]);
  const loading = isPending;
  const { user } = useAuthenticator((context) => [ context.user ]);

  const userInfo = user ? (
    <div>
      <br />
      <h1 className='emphTitle'>User: {user.attributes?.given_name} {user.attributes?.family_name}</h1>
      <h6 className=' '>{user.attributes?.email}</h6>
      <p className='emphText'><em>You have successfully logged into the Metro Housing Boston Property Manager Portal</em></p>
    </div>
  ) : null;

  return (
    <div className='App'>
      <NavMenu/>
      <Banner/>

      <div className='publicContent'>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12}>
            {userInfo}
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={6}>
            <div className='leftContent'>
              <LoginSteps/>
            </div>              
          </Col>
          <Col xs={12} md={12} lg={12} xl={6}>
            <div className='rightContent'> 
              <AWSLoginSection/>
            </div>            
          </Col>
        </Row>
      </div>
      <SITELINKS/>

      <Modal show={loading} centered backdrop='static' keyboard={false}>
        <Modal.Body style={{ textAlign: 'center', fontSize: '1.2em' }}>
          <Spinner animation='border' role='status' style={{ marginBottom: '1em' }} />
          <div>Website loading...logging you into the MHB Portal</div>
        </Modal.Body>
      </Modal>
    </div>
  );
};